export const initialAuthState = {
  token: null,
  errorText: null,
  isAuthenticated: false,
};

export const AUTH_ACTIONS = {
  SET_TOKEN: 'SET_TOKEN',
  SET_ERROR: 'SET_ERROR',
  LOGOUT: 'LOGOUT',
};

export function authReducer(state, action) {
  switch (action.type) {
    case AUTH_ACTIONS.SET_TOKEN:
      return { ...state, token: action.token, isAuthenticated: !!action.token, errorText: null };
    case AUTH_ACTIONS.SET_ERROR:
      return { ...state, errorText: action.errorText };
    case AUTH_ACTIONS.LOGOUT:
      return initialAuthState;
    default:
      return state;
  }
}
